export const STRIPE_PROVIDER = 'stripe';
export const MANUAL_PROVIDER = 'manual';
export const REFUND_TYPE = 'refund';
export const PAYMENT_TYPE = 'payment';
